export const discountData = {
  firstCheckpoint: {
    sum: 500000,
    percent: 0.25,
    kycPercent: 0.75,
  },
  secondCheckpoint: {
    sum: 1000000,
    percent: 0.75,
    kycPercent: 1.25,
  },
}
